
export default {
  data: () => ({
    showTour: false,
  }),

  methods: {
    shouldViewTour () {
      // it cannot be a computed variable beucause it gave us cache issues
      return this.$page.props.brand === 'SBL' && ! localStorage.getItem('firstOrder')
    },
  },
}
